export default __webpack_public_path__ + "static/media/SmithydaoIcon.82f8191d.png";